import React, { useEffect, useState } from 'react';
import { Redirect } from 'react-router-dom';
import ProfileSidebar from '../components/profile/ProfileSidebar';
import { getUserSession } from '../services/authService';
import { fetchFicha } from '../services/fichaService';
import '../styles/profile.css';
import '../styles/admin.css';

const campoLargo = (campo) => (campo.valor || '').length > 90;

const ProfileFichaPage = () => {
  const sessionUser = getUserSession();
  const sessionUserId = sessionUser ? sessionUser.id : null;
  const puedeVerFicha = Boolean(
    sessionUser && (sessionUser.tipo === 'especialista' || sessionUser.tipo === 'administrativo')
  );
  const [ficha, setFicha] = useState(null);
  const [activa, setActiva] = useState('datos');
  const [isLoading, setIsLoading] = useState(true);
  const [errorMessage, setErrorMessage] = useState('');

  useEffect(() => {
    if (!sessionUserId || !puedeVerFicha) {
      setIsLoading(false);
      return undefined;
    }

    let cancelled = false;
    setIsLoading(true);
    setErrorMessage('');

    fetchFicha(sessionUserId)
      .then((data) => {
        if (cancelled || !data) {
          return;
        }

        setFicha(data);
        if (data.secciones && data.secciones[0]) {
          setActiva(data.secciones[0].id);
        }
      })
      .catch((error) => {
        if (!cancelled) {
          setErrorMessage(error.message || 'No se pudo cargar la ficha.');
        }
      })
      .finally(() => {
        if (!cancelled) {
          setIsLoading(false);
        }
      });

    return () => {
      cancelled = true;
    };
  }, [sessionUserId, puedeVerFicha]);

  if (!sessionUser) {
    return <Redirect to="/iniciar-sesion" />;
  }

  if (!puedeVerFicha) {
    return <Redirect to="/perfil" />;
  }

  const secciones = (ficha && ficha.secciones) || [];
  const seccion = secciones.find((item) => item.id === activa) || secciones[0];

  const dibujarCampo = (campo, indiceCampo, enFila, indiceFila) => (
    <div
      key={(enFila ? 'fila-' + indiceFila + '-' : '') + campo.etiqueta + '-' + indiceCampo}
      className={'admin-planilla-field' + (campoLargo(campo) ? ' admin-planilla-field--wide' : '')}
    >
      <span>{campo.etiqueta}</span>
      <p>{campo.valor || '—'}</p>
    </div>
  );

  return (
    <div className="profile-root">
      <div className="profile-layout">
        <ProfileSidebar activeId="ficha" />
        <section className="profile-main">
          <h1 className="profile-review-title">Ficha</h1>
          <p className="profile-review-intro">
            Puedes consultar tus datos. Solo el administrador puede modificarlos.
          </p>
          {isLoading ? <p className="profile-status">Cargando ficha...</p> : null}
          {errorMessage ? <p className="profile-status profile-status--error">{errorMessage}</p> : null}
          {!isLoading && ficha && seccion ? (
            <>
              <div className="admin-planilla-tabs" role="tablist">
                {secciones.map((item, index) => (
                  <button
                    key={item.id}
                    type="button"
                    className={
                      'admin-planilla-tab' + (seccion.id === item.id ? ' admin-planilla-tab--active' : '')
                    }
                    onClick={() => setActiva(item.id)}
                  >
                    {index + 1}. {item.titulo}
                  </button>
                ))}
              </div>
              <div className="admin-planilla-body">
                {seccion.campos && seccion.campos.length > 0 ? (
                  <div className="admin-planilla-grid">
                    {seccion.campos.map((campo, indiceCampo) => dibujarCampo(campo, indiceCampo, false))}
                  </div>
                ) : null}
                {(seccion.filas || []).map((fila, indiceFila) => (
                  <div key={seccion.id + '-' + indiceFila} className="admin-planilla-card">
                    <div className="admin-planilla-grid">
                      {fila.map((campo, indiceCampo) => dibujarCampo(campo, indiceCampo, true, indiceFila))}
                    </div>
                  </div>
                ))}
                {(seccion.campos || []).length === 0 && (seccion.filas || []).length === 0 ? (
                  <p className="admin-muted">Sin datos en esta sección.</p>
                ) : null}
              </div>
            </>
          ) : null}
        </section>
      </div>
    </div>
  );
};

export default ProfileFichaPage;
